import { HolidayCalendarModelDto } from '@treasury/api/bo';
import { DomainEntity } from '../../../../shared';

export class HolidayException extends DomainEntity<HolidayCalendarModelDto> {
    public static from(dto: HolidayCalendarModelDto): HolidayException {
        return new HolidayException(dto);
    }

    public static create(name: string, date: string): HolidayException {
        return new HolidayException({ id: 0, name, date, isPastDue: false });
    }

    public createDefault(): this {
        throw new Error('createDefault not implemented');
    }

    public get id() {
        return this.dto.id;
    }

    public get name() {
        return this.dto.name ?? '';
    }

    public set name(value: string) {
        this.dto.name = value;
    }

    public get date() {
        return this.dto.date ?? '';
    }

    public set date(value: string) {
        this.dto.date = value;
    }

    public get isPastDue() {
        return this.dto.isPastDue ?? false;
    }
}
